import angular from "angular";
import moment from "moment";
import { directiveFactory } from "../../angular-core";

export class ForecastNameUniqueValidationDirective implements ng.IDirective {
    static componentName: string = "forecastNameUniqueValidation";
    static $inject = ["$http", "$q"];

    require = "ngModel";
    restrict = "A";

    link = (scope: $TSFixMe, element: JQLite, attrs: ng.IAttributes, ngModel: $TSFixMe) => {
        scope.$watch(attrs.otherDate, function () {
            ngModel.$validate();
        });
        ngModel.$validators.dateBeforeOtherDate = function (modelValue: $TSFixMe, viewValue: $TSFixMe) {
            var value = modelValue || viewValue;

            var otherDate = scope.$eval(attrs.otherDate);
            if (otherDate && value) {
                if (attrs.validCanEqual) {
                    var isValid = moment(value).isSameOrBefore(moment(otherDate));
                    return isValid;
                }

                var isValid = moment(value).isBefore(moment(otherDate));
                return isValid;
            }
            return true;
        };
    };

    constructor(protected $http: ng.IHttpService, protected $q: ng.IQService) {}
}

angular
    .module("topline.directives")
    .directive(
        ForecastNameUniqueValidationDirective.componentName,
        directiveFactory(ForecastNameUniqueValidationDirective)
    );
